import * as React from 'react';

import { MenuList } from '~shared/components/Menu/MenuList';

export function QuizListMenuList({ children }: { children: React.ReactNode }) {
  return (
    <MenuList className="absolute right-0 mt-2 py-1 bg-white rounded-2 outline-none shadow-menu z-101">
      {children}
    </MenuList>
  );
}
